// extracted by mini-css-extract-plugin
module.exports = {"shareBox":"ShareBox_shareBox__MM66h"};